<ion-header>
  <ion-toolbar>
    <ion-title slot="start">{{ label }}</ion-title>
    <ion-buttons slot="end">
      <ion-button class="close-button" (click)="onCancel()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <x-signature-pad
    label=""
    [control]="signatureControl"
    [width]="canvasWidth()"
    [height]="canvasHeight()"
  ></x-signature-pad>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="header-button cancel-button" (click)="onClear()">
        Clear
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="header-button done-button" (click)="onDone()">
        Done
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
